import React from "react";

import "./SpellChecker.scss";
import { useSpellCheckerViewModel } from "./useSpellCheckerViewModel";
import { IncorrectWord } from "./IncorrectWord";

export const SpellChecker = ({
  name,
  text,
  onTextChange,
  spellCheckerProps
}) => {
  if (typeof text !== "string") {
    throw new Error("Only string value can checked");
  }

  const spellCheckerViewModel = useSpellCheckerViewModel({
    name,
    text,
    onTextChange,
    spellCheckerProps
  });

  return (
    <>
      {spellCheckerViewModel.shouldDisplayErrors && (
        <div className="spell-checker">
          {spellCheckerViewModel.words.map((word, index) => {
            const error = spellCheckerViewModel.getWordError(
              spellCheckerProps.errors,
              word
            );

            return error ? (
              <IncorrectWord
                word={word}
                error={error}
                onWordReplace={spellCheckerViewModel.handleWordReplace}
                onIgnoreClick={spellCheckerViewModel.handleIgnoreClick(word)}
                key={index}
              />
            ) : (
              word
            );
          })}
        </div>
      )}
    </>
  );
};
